export default {
	title: {
		icon: require('@/assets/images/equipment/nckjy/icon.png'),
        name: '农残快检仪',
	},

	// 表头配置
	tableTh: {
		discNoRepeat: '',

		xh: '型号：',
        bcpz: '波长配置：',
        yzlxsfw: '抑制率显示范围：',
        yzlclfw: '抑制率测量范围',
        tsbzqd: '透射比准确度：',
        tsbcfx: '透射比重复性：',
        py: '漂移：',
        yzlxswc: '抑制率示值误差：',
        yzlcfx: '抑制率重复性：',
        yqcc: '仪器尺寸：',
        yqjz: '仪器净重：',
        znczxt: '智能操作系统：',
        zp: '主频：',
        xsfs: '显示方式：',
        dy: '打印：',
        qtsm: '其它说明：',
	},

	// 表格行数据
	tableTr: [
		{
			discNoRepeat: {
				cover: require('@/assets/images/equipment/nckjy/pc_01.png'),
                name: '农药残留快速检测仪'
			},
            xh: 'VTKJ-100-S',
            bcpz: '410nm;',
            yzlxsfw: '0%～100;',
            yzlclfw: '0%～100;',
            tsbzqd: '±1.5%;',
            tsbcfx: '≤0.5%;',
            py: '≤0.005Abs/3min;',
            yzlxswc: '≤10%',
            yzlcfx: '≤5%',
            yqcc: '42×31×20cm;',
            yqjz: '3.6kg;',
            znczxt: '多核处理器：',
            zp: '主频1.88Ghz',
            xsfs: '7英寸高灵敏真彩触摸屏显示，中文操作界面',
            dy: '采用串口5v打印',
            qtsm: '光源采用进口超高亮发光二极管，具有低功耗、高精度、稳定性强 智能恒流稳压，光强自动校准，长时间连续工作光源无温漂现象。 Wifi联网功能，可将数据快速上传电脑，进行数据管理与统计。 USB2.0接口设计，方便数据的存贮和移动 采用DC12v直流供电，安全系统更高',
		},
    ],
    
    part: [
        {
            cover: require('@/assets/images/equipment/nckjy/pc_02.png'),
            title: '快速测定',
            disc: '同时测定多个样品、互不干扰。 自动判断是否合格，更加直观。 测试数据云端记录，自动关联商品批次信息。'
        },
        {
            cover: require('@/assets/images/equipment/nckjy/pc_03.png'),
            title: '提前预防',
            disc: '快速检测农药残留超标，防止食材进入加工环节。 控制农药残留对人体的危害'
        },
    ],
}
